export default function ButtonPrimary({ onClick, children }) {
  return (
    <>
      <button type="button" className="button-primary" onClick={onClick}>
        {children}
      </button>
    </>
  );
}
